module.exports = {"id":"215050","name":"Diego Braghieri","rating":"74","photo":"./data/images/photos/1/215050.png","club":{"name":"Atl. Nacional","logo":"./data/images/clubs/Atl.Nacional.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoBraghieri0.json
// module id = 1071
// module chunks = 0